import React from 'react';

import { Flex } from '@chakra-ui/react';

import { ANSWER_TYPES } from 'constants/ProjectConstants';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

const AnswerType = ({ data }) => {
  const matchingLabel = ANSWER_TYPES.review.find((item) => item.value === data.answerType)?.label;

  return (
    <Flex w="100%" h="100%" alignItems="center">
      <TextBodyMedium>{matchingLabel}</TextBodyMedium>
    </Flex>
  );
};

export default AnswerType;
